export const SIDEBAR_FILTERS = 'filters'
export const SIDEBAR_INTERESTS = 'interests'
export const SIDEBAR_INTERESTS_AND_FILTERS = 'interests,filters'

export default [
  SIDEBAR_FILTERS,
  SIDEBAR_INTERESTS,
  SIDEBAR_INTERESTS_AND_FILTERS
]
